import { render, staticRenderFns } from "./RouteDetail.vue?vue&type=template&id=33fa0406&scoped=true"
import script from "./RouteDetail.vue?vue&type=script&lang=js"
export * from "./RouteDetail.vue?vue&type=script&lang=js"
import style0 from "./RouteDetail.vue?vue&type=style&index=0&id=33fa0406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fa0406",
  null
  
)

export default component.exports